export default "__VITE_ASSET__wzp3GExY__"